import ProtectedPublicContainer from './ProtectedPublicContainer';

export default ProtectedPublicContainer;
